"use client";

import React from "react";

import Image from "next/image";

import { CountBadge } from "@/components/ui/CountBadge";

interface MobileAllFiltersButtonProps {
  onClick: () => void;
  filterCount: number;
  className?: string;
}

export function MobileAllFiltersButton({
  onClick,
  filterCount,
  className = "",
}: MobileAllFiltersButtonProps): React.ReactElement {
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center gap-2 rounded-full border border-black/40 bg-white px-4 py-2 text-sm font-medium text-ink transition-colors hover:bg-gray-50 lg:hidden ${className}`}
    >
      <Image src="/icons/filters-icon.svg" alt="" width={14} height={14} className="shrink-0" />
      <span className="leading-none">All Filters</span>
      <CountBadge count={filterCount} />
    </button>
  );
}
